class PasswordInput extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['password', 'trigger']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this.trigger, 'click', this.onPasswordReveal.bind(this))
  }

  onPasswordReveal () {
    const passwordElement = this.password
    const triggerElement = this.trigger

    if (passwordElement.type === 'password') {
      passwordElement.type = 'text'
      triggerElement.textContent = window.theme.strings.hide
    } else {
      passwordElement.type = 'password'
      triggerElement.textContent = window.theme.strings.show
    }
  }

  get password () {
    return this.els.password.element
  }

  get trigger () {
    return this.els.trigger.element
  }
}

if (!customElements.get('password-input')) {
  customElements.define('password-input', PasswordInput)
}
